var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-popover",
        {
          attrs: { trigger: "click" },
          scopedSlots: _vm._u([
            {
              key: "content",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      ref: "domNode",
                      staticClass: "sc-emoji-picker",
                      attrs: { tabIndex: "0" },
                      on: { blur: _vm.onBlur },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "sc-emoji-picker--content" },
                        _vm._l(_vm.emojiData, function (category) {
                          return _c(
                            "div",
                            {
                              key: category.name,
                              staticClass: "sc-emoji-picker--category",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "sc-emoji-picker--category-title",
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(category.name) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(category.emojis, function (emoji) {
                                return _c(
                                  "span",
                                  {
                                    key: emoji,
                                    staticClass: "sc-emoji-picker--emoji",
                                    on: {
                                      click: function ($event) {
                                        return _vm.emojiClicked(emoji)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(emoji) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _vm.isSlot()
            ? _c(
                "div",
                { on: { click: _vm.emojiClickHandler } },
                [_vm._t("button")],
                2
              )
            : _c(
                "div",
                {
                  staticStyle: { "z-index": "9999" },
                  on: { click: _vm.emojiClickHandler },
                },
                [_c("md-icon", [_vm._v(" sentiment_very_satisfied")])],
                1
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }